module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/color/soccer-8429d7a0eb59296025fe4d47ded4504d.svg";